<template>
  <shared-product-provide :product="product" :fromModule="fromModule" :toModule="toModule">
    <form-group label="Categoria" :required="true" :error="getError('category', product.productId)">
      <multiselect
        v-model="category"
        track-by="name"
        label="name"
        :options="categories"
        selectLabel=""
        selectedLabel=""
        placeholder="Selecione"
      />
    </form-group>
  </shared-product-provide>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import Loader from '@/components/template/Loader'
  import { reverse } from 'lodash'

  export default {
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'walmart'
      },
      maxDescriptionLengthDI: 8000,
      allowDescriptionHtml: false
    },
    data: () => ({
      loadingProductTypes: false,
      loadingAttributes: false,
      category: null,
      categoryIndex: 0,
      categoriesSelect: []
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      formatProduct () {
        this.clearErrors()

        return this.product.variations
          .filter(variation => variation.selected)
          .map(variation => {
            const attributes = Object.keys(variation.attributes)
              .map(attribute => {
                return {
                  id: attribute,
                  label: this.$t(`${attribute}.label`),
                  valueId: variation.attributes[attribute],
                  valueLabel: variation.attributes[attribute]
                }
              })

            let productCategory = null

            if (this.category) {
              const categories = reverse(this.category.categories)

              const category = categories.shift()

              productCategory = {
                name: category.name,
                active: true,
                categoryId: category.code
              }

              if (categories.length > 0) {
                productCategory.parent = this.getParent(categories, productCategory)
              }
            }

            return {
              attributes: attributes,
              brand: this.product.brand,
              color: variation.attributes.color !== undefined ? variation.attributes.color : 'Única',
              size: variation.attributes.size !== undefined ? variation.attributes.size : 'Único',
              description: this.product.description,
              ean: variation.ean,
              height: variation.height,
              images: variation.images.length ? variation.images : null,
              length: variation.length,
              original: {
                product: this.product,
                variation: variation
              },
              price: variation.price,
              sku: variation.sku,
              source: this.fromModule,
              stock: variation.stock,
              title: this.product.title,
              weight: variation.weight,
              width: variation.width,
              category: productCategory
            }
          }
        )
      },
      disabledInputs () {
        return this.product.status === 'sent' || this.product.status === 'error'
      },
      getCategories (productCategories) {
        const categoriesNames = []
        this.getCategoriesRecursive(productCategories, categoriesNames)

        this.categoriesSelect = []

        for (let i in categoriesNames) {
          const categories = categoriesNames[i]

          const categoryName = []

          for (let j in categories) {
            const category = categories[j]

            categoryName.push(category.name)
          }

          this.categoriesSelect.push({
            name: categoryName.join(' > '),
            categories: categories
          })
        }

        return this.categoriesSelect
      },
      getCategoriesRecursive (productCategories, categoriesNames) {
        for (let i in productCategories) {
          const category = productCategories[i]

          if (!categoriesNames[this.categoryIndex]) {
            categoriesNames[this.categoryIndex] = []
          }

          categoriesNames[this.categoryIndex].push({
            name: category.name,
            code: category.code
          })

          if (category.children !== null) {
            this.getCategoriesRecursive(category.children, categoriesNames)
          } else {
            this.categoryIndex++
          }
        }
      },
      getParent (categories) {
        for (let i = 0; i <= (categories.length - 1); i++) {
          const category = categories[i]

          let parent = null
          if (categories[i + 1]) {
            parent = this.getParentRecursive(categories, i)
          }

          return {
            name: category.name,
            active: true,
            categoryId: category.code,
            parent: parent
          }
        }
      },
      getParentRecursive (categories, currentKey) {
        for (let i = currentKey + 1; i < categories.length; i++) {
          const category = categories[i]

          let parent = null
          if (categories[i + 1]) {
            parent = this.getParentRecursive(categories, i)
          }

          return {
            name: category.name,
            active: true,
            categoryId: category.code,
            parent: parent
          }
        }
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ]),
      categories () {
        return this.getCategories(this.product.categories)
      }
    },
    components: {
      SharedProductProvide,
      FormGroup,
      Multiselect,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Product.vue?db45bcb0